import { Link } from 'react-router-dom';

import { SiteLayout } from '@/components/SiteLayout';

export const NotFoundRoute = () => (
  <SiteLayout>
    <section className="px-6 py-16 md:py-24">
      <div className="mx-auto max-w-2xl text-center">
        <h1 className="font-serif text-3xl font-semibold text-text-primary md:text-4xl">
          Page not found
        </h1>
        <p className="mt-6 text-lg text-text-secondary">
          There is nothing at this address. Try the{' '}
          <Link to="/" className="underline hover:text-text-primary">
            home page
          </Link>{' '}
          or the{' '}
          <Link to="/blog" className="underline hover:text-text-primary">
            blog
          </Link>
          .
        </p>
      </div>
    </section>
  </SiteLayout>
);
